import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  gradesLabel: {
    id: 'product_jp_card_guidance_grades_label',
    defaultMessage: 'About condition',
  },
  gradesDescrition: {
    id: 'product_jp_card_guidance_grades_description',
    defaultMessage:
      '"Product condition" refers to the appearance of the device, such as the body and screen. While the condition and price vary by grade, all products are guaranteed to function 100% properly, with no difference in performance. From like-new items to more affordable options, you can choose the one that best suits your needs.',
  },
  batteryLabel: {
    id: 'product_jp_card_guidance_battery_label',
    defaultMessage: 'About battery health',
  },
  batteryDescrition: {
    id: 'product_jp_card_guidance_battery_description',
    defaultMessage:
      'Devices sold on Back Market have a battery capacity of 80–100% as one of the quality standards. If you prefer a guaranteed 100% battery capacity, you can choose the new battery option.',
  },
  simLabel: {
    id: 'product_jp_card_guidance_sim_label',
    defaultMessage: 'About SIM Cards',
  },
  simDescription: {
    id: 'product_jp_card_guidance_sim_description',
    defaultMessage:
      'A SIM allows you to activate a phone plan from your carrier and holds information like your phone number.',
  },
  processorLabel: {
    id: 'product_jp_card_guidance_processor_label',
    defaultMessage: 'About processor',
  },
  processorDescription: {
    id: 'product_jp_card_guidance_processor_description',
    defaultMessage:
      'Processor is the part that helps your smartphone or computer run smoothly.',
  },
  grade9: {
    id: 'product_jp_grade_9',
    defaultMessage: 'Premium',
  },
  grade10: {
    id: 'product_jp_grade_10',
    defaultMessage: 'A grade (Excellent)',
  },
  grade11: {
    id: 'product_jp_grade_11',
    defaultMessage: 'B grade (Good)',
  },
  grade12: {
    id: 'product_jp_grade_12',
    defaultMessage: 'C grade (Fair)',
  },
  batteryUpdatedStandard: {
    id: 'product_jp_battery_updated_standard',
    defaultMessage: 'Standard (80%+)',
  },
  batteryUpdated9099: {
    id: 'product_jp_battery_updated_90_99',
    defaultMessage: 'Battery 90-99%',
  },
  batteryUpdatedNew: {
    id: 'product_jp_battery_updated_new',
    defaultMessage: 'New battery',
  },
  batteryDescriptionUpdated: {
    id: 'product_jp_card_guidance_battery_description_updated',
    defaultMessage:
      'At Back Market, we offer three battery options to match your needs: Standard (80%+ capacity), Battery 90-99% capacity, and New (100% capacity with a brand-new battery).',
  },
  batteryUpdatedStandardSublabel: {
    id: 'product_jp_battery_updated_standard_sublabel',
    defaultMessage: 'Battery health between 80-89%',
  },
  batteryUpdated9099Sublabel: {
    id: 'product_jp_battery_updated_90_99_sublabel',
    defaultMessage: 'Battery health between 90-99%',
  },
  batteryUpdatedNewSublabel: {
    id: 'product_jp_battery_updated_new_sublabel',
    defaultMessage: 'New battery, 100% health',
  },
  tradeInStepTitle: {
    id: 'product_jp_trade_in_step_title',
    defaultMessage: 'Trade-in',
  },
} as Record<string, I18nDefinition>
